export enum PaymentTermsEnum {
  PRE_PAYMENT = 'prepayment',
  POST_PAYMENT = 'post_pay',
  CASH_ON_DELIVERY = 'cash_on_delivery',
  PURCHASE_ON_INVOICE = 'purchase_on_invoice',
}
